export enum TwoFactorAuthenticationMethod {
    SMS = 'SMS',
    EMAIL = 'EMAIL'
}
